import { gql } from "@apollo/client";
import { useState } from "react";
import { useQuery } from "@apollo/client";
import useAuth from "~/src/auth/hooks/use-auth";
import { checkErrors } from "~/src/utils/errors";
import { PayrollScale } from "../types";

type dataType = {
  account: {
    payrollScales: PayrollScale[];
  };
};

export const GET_PAYROLL_SCALES = gql`
  query payrollScales($search: String, $offset: Int!, $limit: Int!) {
    account {
      id
      payrollScales(search: $search, offset: $offset, limit: $limit) {
        id
        name
        config
        createdAt
        updatedAt
      }
    }
  }
`;

const PAGE_SIZE = 200;

export const usePayrollScales = (searchText: string) => {
  const auth = useAuth();
  const [isInitialFetch, setIsInitialFetch] = useState(true);
  const [limit, setLimit] = useState(PAGE_SIZE);
  const [offset, setOffset] = useState(0);

  const { loading, data, fetchMore } = checkErrors(
    useQuery(GET_PAYROLL_SCALES, {
      variables: auth.addVals(GET_PAYROLL_SCALES, {
        search: searchText,
        offset,
        limit
      }),
      fetchPolicy: isInitialFetch ? "network-only" : "cache-first",
      notifyOnNetworkStatusChange: true
    })
  );

  const payrollScales = data?.account?.payrollScales ?? [];
  const totalResults = payrollScales.length;

  return {
    loading: isInitialFetch && loading,
    loadingMore: !isInitialFetch && loading,
    payrollScales,
    hasMore: payrollScales.length < totalResults,
    fetchMore: () => {
      if (payrollScales.length < totalResults) {
        setIsInitialFetch(false);
        const newOffset = offset + limit;
        setOffset(newOffset);

        fetchMore({
          variables: {
            offset: newOffset,
            limit: PAGE_SIZE
          },
          fetchPolicy: "network-only"
        }).then(({ data }: { data: dataType }) => {
          setLimit(limit + data.account.payrollScales.length);
        });
      }
    }
  };
};
